import { createContext, useContext } from 'react';

// What every part of the editor reads: the controller (document, selection, actions) and
// what the host provided (brand kit, image gallery, read-only state). One context instead
// of threading the same props through the rail, the panels and the inspector.
export const ArtEditorContext = createContext(null);
export const useArtEditorContext = () => useContext(ArtEditorContext);
